<template>
  <div class="page-top">
    <div
      class="hero is-bold has-background"
      :style="{ backgroundImage: `url(${image})` }"
    >
      <div class="hero-body">
        <div class="container">
          <div class="columns is-mobile">
            <div class="column has-text-centered">
              <h1 class="title">{{ title }}</h1>
              <br />
              <h2 class="title">{{ subtitle }}</h2>
            </div>
          </div>
        </div>
      </div>
    </div>

    <slot name="breadcrumbs">
      <div class="breadcrumbs" v-if="breadcrumbs">
        <div class="container">
          <span class="is-pulled-left icon"><i class="fas fa-link"/></span>
          <nav class="breadcrumb" aria-label="breadcrumbs">
            <ul>
              <template v-for="crumb in breadcrumbs">
                <router-link
                  tag="li"
                  active-class="is-active"
                  :to="crumb.route"
                  exact
                >
                  <router-link :to="crumb.route" exact>{{
                    crumb.title
                  }}</router-link>
                </router-link>
              </template>
            </ul>
          </nav>
        </div>
      </div>
    </slot>

    <slot />
  </div>
</template>

<style lang="scss" scoped>
@import '../styles/_variables';

.hero-body {
  min-height: 400px !important;
  padding: 7rem 1.5rem;
}
.page-top {
  .hero.has-background {
    background: no-repeat top center;
    background-size: cover;

    h1,
    h2 {
      &.title {
        display: inline-block;
        padding: 5px 10px;

        font-weight: 400;
        bottom: 15px;
      }
    }
    h1.title {
      font-size: 4rem;
      text-transform: uppercase;
      color: limegreen;
    }
    h2.title {
      font-size: 2.5rem;

      color: rgb(100, 100, 100);
    }
  }

  .breadcrumbs {
    background-color: $primary;
    color: $white;
    padding: 10px;

    .icon {
      margin-right: 5px;
    }

    li::before {
      color: $white-ter;
    }

    a {
      color: $white;

      &:hover {
        text-decoration: underline;
        color: $white;
      }
    }
  }
}
</style>

<script>
export default {
  props: ['breadcrumbs', 'title', 'subtitle', 'image']
}
</script>



// WEBPACK FOOTER //
// src/global/components/PageImageTop.vue